'use client'

import styled from "styled-components";
import {Drawer, Layout} from "antd";
import {getColor} from "@/pipes/theme.pipe";
import LogoIcon from "@/public/icons/branding/logo.svg";
import {getSectionPaddingsInline} from "@/components/UI/Section/Section.utils";

const { Header} = Layout;

export const HeaderStyled = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: clamp(20px, 4vw, 24px) ${getSectionPaddingsInline('md')};
    background: ${getColor('secondary', '700')};
    width: 100%;
    z-index: 1000;
`

export const HeaderLogo = styled(LogoIcon)``

export const HeaderNavbarWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    gap: clamp(20px, 3vw, 50px);
    flex: 1;
    
    header {
        height: fit-content !important;
        line-height: 20px !important;
        align-self: center;
        
        ul {
            border: none !important;
        }
        
        li {
            font-size: clamp(10px, 1.5vw, 16px);
            padding-inline: clamp(5px, 4vw, 20px) !important;
        }
    }
    
    @media (max-width: 1015px) {
        display: none;
    }
`

export const HeaderNavbar = styled(Header)`
    display: flex;
    align-items: center;
    background: transparent;
    flex: 1;
    padding: 0 0 0 clamp(10px, 1.5vw, 20px) !important;
    
    ul {
        display: flex;
        justify-content: end;
        width: fit-content !important;
        border: none;
        
        li {
            color: ${getColor('natural', '100')} !important;
            width: fit-content !important;
        }
    }
`

export const MobileNavbarWrapper = styled.div`
    display: none;
    
    @media (max-width: 1015px) {
        cursor: pointer;
        display: block;
    }
`

export const LogoutBtnBurgerGroupWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 30px;
`

export const MobileNavbar = styled(Drawer)`
    width: 100vw;
    background: ${getColor('primary')} !important;
    text-align: center;
    
    span {
        color: ${getColor('natural', '900')} !important;
    }
`

export const HeaderNavbarButtonsWrapper = styled.div`
    display: flex;
    gap: 13px;
    height: fit-content;
    align-self: center;
    text-wrap: nowrap;
    
    button {
        font-size: 14px !important;
    }
`

export const LanguageSelectWrapper = styled.div`
    width: fit-content;
    margin: 0 auto;
`